const cards = [
  {
    title: '某顶流艺人深夜密会神秘女子，酒店同框照曝光引热议',
    desc: '据知情人士透露，该艺人近期行程与公开信息存在多处矛盾，粉丝群体已炸开锅。更多细节正在持续跟进中，关注51吃瓜在线观看最新进展。',
    tag: '娱乐圈',
    hot: '9.8万',
    time: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20illustration%20of%20entertainment%20gossip%20scene%2C%20silhouettes%20of%20people%20walking%20at%20night%2C%20soft%20orange%20and%20pink%20gradient%2C%20mysterious%20atmosphere%2C%20modern%20minimal%20art%20style%2C%20clean%20composition%2C%20editorial%20illustration%20with%20geometric%20shapes&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '网红圈再爆大瓜，千万粉丝博主涉嫌虚假宣传遭集体维权',
    desc: '多位消费者联合发声，指控该网红推荐的多个产品存在质量问题和夸大宣传。目前相关品牌方已紧急下架涉事商品，51黑料在线观看持续关注。',
    tag: '网红圈',
    hot: '7.2万',
    time: '5小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20showing%20social%20media%20controversy%2C%20floating%20comment%20bubbles%20with%20warning%20symbols%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20modern%20flat%20design%2C%20clean%20lines%2C%20minimalist%20composition%2C%20editorial%20style&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '热门综艺录制现场突发意外，节目组紧急叫停引发猜测',
    desc: '事发后节目官方社交账号未作回应，但多位参与录制嘉宾已先后发文暗示。知情人士称涉及嘉宾之间的严重矛盾冲突，吃瓜在线视频持续追踪。',
    tag: '综艺',
    hot: '6.5万',
    time: '8小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20studio%20scene%20illustration%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20rose%20tones%2C%20spotlight%20effects%2C%20modern%20minimal%20art%2C%20clean%20geometric%20shapes%2C%20editorial%20composition%2C%20soft%20gradients&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '年度最炸裂黑料：某剧组内部聊天记录被曝光，涉及多位主创',
    desc: '记录内容涉及片酬分配不均、剧组霸凌等多重问题，已有多位业内人士转发评论。圈内人士表示此事可能引发行业连锁反应，黑料吃瓜免费看完整内容。',
    tag: '影视圈',
    hot: '12.3万',
    time: '1小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20leaked%20documents%20and%20chat%20messages%2C%20warm%20orange%20and%20soft%20pink%20color%20scheme%2C%20floating%20paper%20fragments%2C%20modern%20minimal%20style%2C%20clean%20composition%2C%20editorial%20design%20with%20geometric%20elements&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '知名歌手新歌被指抄袭海外作品，制作人连夜发声明回应',
    desc: '网友对比音频后列出多处相似段落，相关话题迅速登上热搜。该歌手过往多首热单也被翻出进行对比分析，51吃瓜在线观看为你带来最全梳理。',
    tag: '音乐圈',
    hot: '5.6万',
    time: '12小时前',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20music%20and%20controversy%20illustration%2C%20floating%20musical%20notes%20with%20comparison%20lines%2C%20warm%20coral%20and%20cream%20gradient%2C%20modern%20flat%20design%2C%20clean%20geometric%20shapes%2C%20editorial%20style%2C%20soft%20atmosphere&width=800&height=500&seq=card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门黑料精选
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            全网最新最热的吃瓜内容，每日精选不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500"></i>
                    {card.hot} 热度
                  </span>
                  <span>{card.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}